import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { IoMdPeople } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";

const route = all_routes;
export const SidebarData = [
  {
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-dashboard",
        submenu: false,
        showSubRoute: false,
        link: route.adminDashboard,
      },
    ],
  },
  {
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Companies",
        icon: "ti ti-user-up",
        submenu: false,
        showSubRoute: false,
        link: route.adminCompaniesList,
      },
      {
        label: "Manage devices",
        icon: "ti ti-user-up",
        submenu: false,
        showSubRoute: false,
        link: route.adminDevices,
      },

      {
        label: "Tickets",
        icon: "ti ti-code",
        submenu: false,
        showSubRoute: false,
        link: route.manageTickets,
      },
      {
        label: "Phone Numbers",
        icon: "ti ti-phone-plus",
        submenu: true,
        showSubRoute: true,
        submenuItems: [
          {
            label: "DID Numbers",
            link: route.adminDidNumbers,
            icon: <IoMdPeople />,
          },
          {
            label: "DID Settings",
            link: route.adminDidSettings,
            icon: <IoMdPeople />,
          },
          {
            label: "Call Rates",
            link: route.adminCallRates,
            icon: <IoMdPeople />,
          },
        ],
      },

      {
        label: "Plans & Coupons",
        icon: "ti ti-crown",
        submenu: true,
        showSubRoute: true,
        submenuItems: [
          {
            label: "Manage Plans",
            link: route.adminPlans,
            icon: <IoMdPeople />,
          },
          {
            label: "Manage Coupons",
            link: route.adminCoupons,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Notifications",
        icon: "ti ti-bell",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Direct Notification",
            link: route.adminDirectNotification,
            icon: <IoMdPeople />,
          },
          {
            label: "Email Notification",
            link: route.adminEmailNotification,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "System Emails",
        icon: "ti ti-mail",
        submenu: false,
        showSubRoute: false,
        link: route.adminSystemEmails,
      },
      {
        label: "Billing",
        icon: "ti ti-credit-card",
        submenu: false,
        showSubRoute: false,
        link: route.adminBilling,
      },
      {
        label: "WhatsApp",
        icon: "ti ti-brand-whatsapp",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Chat",
            link: route.adminWhatsappChat,
            icon: <FaWhatsapp />,
          },
          {
            label: "History",
            link: route.adminWhatsappHistory,
            icon: <FaMessage />,
          },
          {
            label: "Campaigns",
            link: route.adminWhatsappCampaigns,
            icon: <IoMdPeople />,
          },
          {
            label: "Templates",
            link: route.adminWhatsappTemplates,
            icon: <IoMdPeople />,
          },
          {
            label: "Settings",
            link: route.adminWhatsappSetting,
            icon: <IoMdPeople />,
          },
          {
            label: "Automations",
            link: route.adminAutomations,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "API Logs",
        icon: "ti ti-terminal-2",
        submenu: false,
        showSubRoute: false,
        link: route.adminApiLogs,
      },
      {
        label: "API Docs",
        icon: "ti ti-cloud-cog",
        submenu: false,
        showSubRoute: false,
        link: route.api,
      },
      {
        label: "User Sessions",
        icon: "ti ti-device-laptop",
        submenu: false,
        showSubRoute: false,
        link: route.adminUserSessions,
      },
      {
        label: "User Activity",
        icon: "ti ti-activity",
        submenu: false,
        showSubRoute: false,
        link: route.adminUserActivity,
      },
      {
        label: "Settings",
        icon: "ti ti-settings",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Profile Settings",
            link: route.adminProfile,
            icon: <IoMdPeople />,
          },
          {
            label: "Security",
            link: route.adminSecurity,
            icon: <IoMdPeople />,
          },
        ],
      },
    ],
  },
];
